define('presentation/common/callDetails/presentationObjects/callDetailsWebChatPresentationObject',[],function() {
    return function(){
        const self = this;

        self.webChatId = null;
        self.scriptName = null;
        self.employeeName = null;
        self.participantName = null;
        self.participantEmailAddress = null;
        self.domain = null;
        self.webChatTranscript = [];
    };
});

